import React from 'react';
import { Check, Minus } from 'lucide-react';
import { motion } from 'framer-motion';
import { useTheme } from 'next-themes';

interface CustomCheckboxProps {
  state: 'checked' | 'unchecked' | 'partial';
  className?: string;
}

const CustomCheckbox: React.FC<CustomCheckboxProps> = ({ state, className = '' }) => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <motion.span
      initial={false}
      animate={{
        backgroundColor: state === 'unchecked' ? 'transparent' : isDark ? 'white' : 'black',
      }}
      className={`inline-flex items-center justify-center w-4 h-4 border rounded mr-2 transition-colors ${
        state !== 'unchecked' 
          ? `border-${isDark ? 'white' : 'black'} ${isDark ? 'text-black' : 'text-white'}`
          : 'border-muted-foreground'
      } ${className}`}
    >
      <motion.div
        initial={false}
        animate={{
          scale: state === 'unchecked' ? 0 : 1,
        }}
      >
        {state === 'partial' ? (
          <Minus className="w-3 h-3" />
        ) : state === 'checked' ? (
          <Check className="w-3 h-3" />
        ) : null}
      </motion.div>
    </motion.span>
  );
};

export default CustomCheckbox;